"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var auth_1 = require("firebase/auth");
var react_1 = __importDefault(require("react"));
var react_redux_firebase_1 = require("react-redux-firebase");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Text_1 = __importDefault(require("shared/components/Text"));
var QRInput_1 = __importDefault(require("./QRInput"));
var Relogin = function (_a) {
    var onRelogIn = _a.onRelogIn, setNeedsSubmitReauth = _a.setNeedsSubmitReauth;
    var firebase = (0, react_redux_firebase_1.useFirebase)();
    var _b = __read(react_1.default.useState(''), 2), password = _b[0], setPassword = _b[1];
    var _c = __read(react_1.default.useState(''), 2), passError = _c[0], setPassError = _c[1];
    var submitReauth = function (pass) { return __awaiter(void 0, void 0, void 0, function () {
        var auth, currentUser, credential, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    auth = (0, auth_1.getAuth)(firebase.app);
                    currentUser = auth.currentUser;
                    if (!currentUser)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    credential = auth_1.EmailAuthProvider.credential(currentUser.email, pass);
                    return [4 /*yield*/, (0, auth_1.reauthenticateWithCredential)(currentUser, credential)];
                case 2:
                    _a.sent();
                    setNeedsSubmitReauth(false);
                    return [4 /*yield*/, (0, end2end_1.delay)(500)];
                case 3:
                    _a.sent(); // ToDo: see if this is really necessary
                    return [4 /*yield*/, onRelogIn()];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    err_1 = _a.sent();
                    if (err_1.code === 'auth/too-many-requests') {
                        setPassError('Too Many Requests. Try again later.');
                        return [2 /*return*/];
                    }
                    setPassError('Wrong password');
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, color: "riverstone", textAlign: "center" }, { children: "Relogin required" })), (0, jsx_runtime_1.jsx)(QRInput_1.default, { type: "password", value: password, placeholder: "password", onChange: function (e) {
                    setPassError('');
                    setPassword(e.target.value);
                }, onKeyDown: function (e) { return e.key === 'Enter' && submitReauth(password); }, error: !!passError, helperText: passError }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ size: "large", onClick: function () { return submitReauth(password); }, fullWidth: true }, { children: "Relogin" }))] })));
};
exports.default = Relogin;
